import {useContext, useEffect, useState} from "react";
// @ts-ignore
import {APIContext} from "../Globals.tsx";
// @ts-ignore
import {ContractsDTO} from "../model/ContractsDTO.tsx";
// @ts-ignore
import editIcon from "../../img/edit.png";
// @ts-ignore
import deleteIcon from "../../img/delete.png";
// @ts-ignore
import TextInputWeex from "../elements/TextInputWeex";
import NumberInputWeex from "../elements/NumberInputWeex";
// @ts-ignore
import SelectWeex from "../elements/SelectWeex";
import {ContractDTO} from "../model/ContractDTO";
import {repeats} from "../ToDos"
// @ts-ignore
import {Modal} from "../Modal.tsx";
// @ts-ignore
import {SettingsCard} from "./SettingCard.tsx";

export default function ContractSettings(){
  const [contracts, setContracts] = useState<ContractsDTO>({});
  const [addNewContract, setAddNewContract] = useState<boolean>(false);
  const [contractInput, setContractInput] = useState<ContractDTO | null>(null);
  const {getContracts, saveContract} = useContext(APIContext)

  useEffect(() => {
    getContracts().then((contracts) => {
      setContracts(contracts);
    });
  }, []);

  useEffect(() => {
    if(!addNewContract) setContractInput(null)
  }, [addNewContract])

  function submit(){
    saveContract(contractInput).then((e)=> {
      if(e){
        window.location.reload()
      }
    })
  }

  function renderContract(contract: ContractDTO){
    return <SettingsCard onEdit={() => {
      setContractInput(contract);
      setAddNewContract(true);
    }} onDelete={null}>
      <h4>{contract.name}</h4>
      <label>Vertagstyp:</label><p>{repeats.find(e => e.value === contract?.repeat).label}</p><br/>
      <label>Tickets:</label><p>{contract?.tickets}</p><br/><br/>
      {contract.months && <div><label>Laufzeit in Monate:</label><p>{contract.months}</p><br/></div>}
    </SettingsCard>
  }

  function handleChange(field: string, value: any){
    setContractInput({...contractInput, [field]: value});
  }

  useEffect(() => {
    if(contractInput?.repeat === "all_in")
      handleChange("tickets", -1)
    else if(contractInput?.tickets < 1)
      handleChange("tickets", "")
  }, [contractInput?.repeat]);

  function renderContractInput(){
    return <Modal
      actionP={submit}
      actionS={() => setAddNewContract(false)}
      buttonS={"Schließen"}
      buttonP={"Speichern"}
      valid={contractInput?.name && contractInput?.tickets >= -1 && contractInput?.repeat}>
      <TextInputWeex placeholder={"Name"} value={contractInput?.name ?? ""} onChange={(e) => {
        setContractInput({...contractInput, name: e.target.value});
      }}/>
      <SelectWeex options={repeats} valueRaw={contractInput?.repeat} onChange={(e) => handleChange("repeat", e.value)}
                  placeholder={"Vertragstyp"} isClearable={false}/>
      {(isNaN(contractInput?.tickets) || contractInput?.tickets >-1) && <NumberInputWeex value={contractInput?.tickets} onChange={e => handleChange("tickets", e)}
                        placeholder={"Tickets"}/>}
      <NumberInputWeex value={contractInput?.months} onChange={e => handleChange("months", e)}
                       placeholder={"Laufzeit in Monate"}/>
    </Modal>
  }

  return (<div style={{position: "relative", width: "100%", height: "100%"}}>
    {addNewContract && renderContractInput()}

    <h3>Verträge</h3>
    <button className={"primarybutton"} onClick={() => setAddNewContract(true)}>Neuer Vertrag</button>
    <br/>
    <div id={"course_types"} className={"news-container"}>
      {contracts.contracts?.map((contract) => renderContract(contract))}
    </div>
  </div>);
}
